import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Modal } from 'components/atoms/modal';
import { ModalTitle } from 'components/atoms/modal/title';
import { BodyShort01, Text02 } from 'components/styles';
import { useTranslate } from 'hooks/use-translation';
const Body = styled.div`
  ${BodyShort01};
  ${Text02};
  padding-bottom: var(--spacing-05);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
`;
const Track = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: var(--cool-gray-20);
  overflow: hidden;
`;
const Fill = styled.div`
  height: 100%;
  width: ${({ $percent })=>`${Math.min(100, Math.max(0, $percent))}%`};
  background: var(--primary-color);
  transition: width 0.2s ease-out;
`;
const Status = styled.div`
  ${BodyShort01};
  color: var(--cool-gray-70);
`;
const phaseMessage = (phase, percent, translate, errorMessage)=>{
    if (phase === 'error') {
        return errorMessage || translate('desktop.updater.failed.body');
    }
    if (phase === 'installing') {
        return translate('desktop.updater.installing');
    }
    if (phase === 'relaunching') {
        return translate('desktop.updater.relaunching');
    }
    return translate('desktop.updater.downloading.progress', {
        pct: percent
    });
};
export const DesktopUpdateProgressModal = ({ open, phase, percent, version, errorMessage, onDismissError })=>{
    const translate = useTranslate();
    const isError = phase === 'error';
    const title = isError ? translate('desktop.updater.failed.title') : translate('desktop.updater.downloading.title');
    return /*#__PURE__*/ _jsx(Modal, {
        open: open,
        centered: true,
        width: 420,
        closable: isError,
        maskClosable: false,
        keyboard: isError,
        footer: isError ? undefined : null,
        okText: translate('ok'),
        cancelButtonProps: {
            style: {
                display: 'none'
            }
        },
        onOk: onDismissError,
        onCancel: onDismissError,
        title: /*#__PURE__*/ _jsx(ModalTitle, {
            primaryTitle: /*#__PURE__*/ _jsx("span", {
                "data-cy": "desktop-updater.title",
                children: title
            })
        }),
        "data-cy": "desktop-updater.progress-modal",
        children: /*#__PURE__*/ _jsxs(Body, {
            children: [
                version ? /*#__PURE__*/ _jsx("div", {
                    "data-cy": "desktop-updater.version",
                    children: translate('desktop.updater.body', {
                        version
                    })
                }) : null,
                /*#__PURE__*/ _jsx(Status, {
                    "data-cy": "desktop-updater.status",
                    children: phaseMessage(phase, percent, translate, errorMessage)
                }),
                !isError ? /*#__PURE__*/ _jsx(Track, {
                    "data-cy": "desktop-updater.progress-bar",
                    children: /*#__PURE__*/ _jsx(Fill, {
                        $percent: phase === 'downloading' ? percent : phase === 'relaunching' ? 100 : 95
                    })
                }) : null
            ]
        })
    });
};
